import React from 'react'
import Modal from 'components/Modal/Modal'
import SurpriseBoxList from './SurpriseBoxList'
import PromotionForm from './PromotionForm'
import PromotionDetails from './PromotionDetails'
import { FORM_MODAL_ID, DETAILS_MODAL_ID } from './constants'

const SurpriseBox = () => (
  <Modal.Provider>
    <SurpriseBoxList />
    <Modal title="Surprise Box Promotion" id={FORM_MODAL_ID} width={760}>
      <PromotionForm />
    </Modal>
    <Modal title="Promotion Details" id={DETAILS_MODAL_ID} width={640}>
      <PromotionDetails />
    </Modal>
  </Modal.Provider>
)

export default SurpriseBox
